import { render, staticRenderFns } from "./ConfiguracoesFreteHeader.vue?vue&type=template&id=33bd3dbf"
import script from "./ConfiguracoesFreteHeader.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesFreteHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports